import Input from "../campaign/wizard/Input";

const ERROR_BORDER = "border-red-500 focus:border-red-500 focus:ring-red-500/35";

export default function IndustryCategoryFields({
  formData,
  isReadOnly,
  fieldsDisabled = false,
  handleChange,
  handleIndustryChange,
  industryOptions,
  categoryOptions,
  fieldErrors = {},
  wrapperClassName = "col-12 mb-4",
  inputSize = "md",
}) {
  const disabled = isReadOnly || fieldsDisabled;
  const errorClass = inputSize === "sm" ? "mt-1 text-[10px] text-red-600" : "mt-1 text-xs text-red-600 md:text-sm";

  return (
    <div className={wrapperClassName}>
      <div className={`grid grid-cols-1 ${inputSize === "sm" ? "gap-3" : "gap-4"} sm:grid-cols-2`}>
        <div>
          <Input
            as="select"
            label="Industry"
            labelIcon="briefcase"
            name="industry"
            value={formData.industry}
            onChange={handleIndustryChange}
            disabled={disabled}
            options={industryOptions}
            required
            size={inputSize}
            wrapperClassName="mb-0"
            className={fieldErrors.industry ? ERROR_BORDER : ""}
          />
          {fieldErrors.industry ? (
            <p className={errorClass}>{fieldErrors.industry}</p>
          ) : null}
        </div>
        <div>
          <Input
            as="select"
            label="Category"
            labelIcon="diagram-3"
            name="category"
            value={formData.category}
            onChange={handleChange}
            disabled={disabled || !formData.industry}
            options={categoryOptions}
            required
            size={inputSize}
            wrapperClassName="mb-0"
            className={fieldErrors.category ? ERROR_BORDER : ""}
          />
          {fieldErrors.category ? (
            <p className={errorClass}>{fieldErrors.category}</p>
          ) : null}
        </div>
      </div>
    </div>
  );
}
